// extracted by mini-css-extract-plugin
export default {"incorrectBirth":"SignUpIncorrectBirthStep_incorrectBirth__frFy6","warning":"SignUpIncorrectBirthStep_warning__CQuOf","back":"SignUpIncorrectBirthStep_back__Fy7pR"};